export const APP_CONFIG = {
  production: false,
 // environment: 'https://bilddit-testapi.mobikasa.net'
   environment: 'https://dev-lara.bilddit.com'
};
